import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const deleteMatch = (matchId: number) => api.delete(`/matches/${matchId}`);

export const useDeleteMatchMutation = () => {
  return useMutation({
    mutationKey: ['matches'],
    mutationFn: deleteMatch,
  });
};
